export enum VGBType {
    PUB = 'PUB',
    PUN = 'PUN',
    BU ='BU',
    OM = 'OM',
    OE = 'OE',
    EXT = 'Ext',
    ND = 'ND'
}
